import { Component, Input, SimpleChanges } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { TooltipModule } from 'primeng/tooltip';
import { LicenseService } from '../../../../../services/remote/license.service';
import { NotificationService } from '../../../../../services/shared/notification.service';
import { extractMatchingSettings } from '../../license/helpers/licenseHelper';
import { QueryResult } from '../../license/types/licenseTypes';
import { ValidationMessageComponent } from '../../validation-message/validation-message.component';

@Component({
  selector: 'cognos-license-details-model',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    FloatLabelModule,
    InputTextModule,
    InputNumberModule,
    TextareaModule,
    DividerModule,
    TooltipModule,
    ValidationMessageComponent,
  ],
  templateUrl: './license-details-model.component.html',
  styleUrl: './license-details-model.component.scss',
})
export class LicenseDetailsModelComponent {
  @Input() model: any;
  @Input({ required: true }) licenseId!: string;

  public formGroup!: FormGroup;

  constructor(
    private _licenseService: LicenseService,
    private _notificationService: NotificationService,
    private fb: FormBuilder
  ) {
    this.formGroup = this.fb.group({
      modelName: ['', Validators.required],
      visionModelName: ['', Validators.required],
      modelTopK: [, Validators.required],
      modelTopP: [null, Validators.required],
      temperature: [null, Validators.required],
      topK: [null, Validators.required],
      memoryMessages: [null, Validators.required],
      prompt: ['', Validators.required],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model'] && changes['model'].currentValue) {
      const content = this.model.content;

      this.formGroup.patchValue({
        modelName: content.modelName ?? '',
        visionModelName: content.visionModelName ?? '',
        modelTopK: content.modelTopK ?? null,
        modelTopP: content.modelTopP ?? null,
        temperature: content.temperature ?? null,
        topK: content.topK ?? null,
        memoryMessages: content.memoryMessages ?? null,
        prompt: content.prompt ?? '',
      });
    }
  }

  public onSaveClick(): void {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      this._notificationService.showErrorNotification(
        'Please check the form fields.'
      );
      return;
    }

    this._updateSettings(this.formGroup);
  }

  private async _updateSettings(formGroup: FormGroup) {
    const typeValue = 'model';

    const newSettings = extractMatchingSettings(this.model.content, formGroup);

    const updateResult = await this._licenseService.updateSettings(
      newSettings,
      typeValue,
      this.licenseId
    );

    if (updateResult === QueryResult.ok) {
      this._notificationService.showSuccessNotification(
        'Data was successfully saved.'
      );
      this.formGroup.markAsPristine();
    } else {
      this._notificationService.showErrorNotification(
        'Error saving changes. Please try again.'
      );
    }
  }
}
